import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

export default function Loading() {
    return <div className="vh-100 vw-100 d-flex justify-content-center align-items-center">
        <LoadingOutlined />
    </div>
}